import React from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../lib/api";

function getVisitorId() {
    let id = localStorage.getItem("pmv_visitor_id");
    if (!id) {
        id = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now())
            .replace(/-/g, "")
            .slice(0, 32);
        localStorage.setItem("pmv_visitor_id", id);
    }
    return id;
}

/**
 * Tracks page views on route change (excluding /admin/*).
 * Mount once at the App level.
 */
export default function VisitTracker() {
    const location = useLocation();

    React.useEffect(() => {
        if (location.pathname.startsWith("/admin")) return;
        const payload = {
            visitor_id: getVisitorId(),
            path: location.pathname,
            referrer: document.referrer || "",
        };
        // Fire & forget — never block UI
        api.post("/track", payload).catch(() => {});
    }, [location.pathname]);

    return null;
}
